'use strict';
/*
 * Module: activationApp
 * Controller: rootController
 */
(function(angular) {
  angular.module('activationApp')
    .controller('rootController', [
      '$scope',
      '$rootScope',
      '$window',
      function(
        $scope,
        $rootScope,
        $window) {
        var menuLoggedOut = [
          { name: "Features", link: '/features'},
          { name: "TV", link: '/tv' },
          { name: "Movies", link: '/movies'},
          { name: "Packages", link: '/packages'},
          { name: "Account", link: '/account/signin'},
          { name: "Search", iconClass: 'icon-search', link: '/search', noCollapse: true }
        ];

        $scope.getCurrentMenu = function() {
          return menuLoggedOut;
        };

        $scope.menuClicked = function(menuItem) {
          if (angular.isUndefined(menuItem)) {
            return;
          }

          if (angular.isDefined(menuItem.action)) {
            switch (menuItem.action.toUpperCase()) {
            case "HOME":
              $window.location = ('/');
            }
          }

          if (angular.isDefined(menuItem.link)) {
            $window.location = (menuItem.link);
          }
        };
      }]);
})(angular);

